import { isEdgeParams } from '@iotv/iotv-v3-types';
import '@mui/lab';
export const isCurriedNodeGeneratorQueryPlusExtractorParmas = (params) => {
    return isEdgeParams(params.edgeFilter) && typeof params.query === 'function';
};
